import React from "react";
import { StepBubbles } from "~/components/blocks";
import {
  Margin,
  Title,
  Button,
} from "~/components/elements";
import history from "~/routes/history";
import { Grid } from "@material-ui/core";
import isMobile from "~/hooks/isMobile";

import * as S from "./styles";

export default function ConfirmationRegisterContent({ step }) {
  const mobile = isMobile();

  return (
    <S.PageContainer>
      <Grid container justifyContent="center">
        <Margin>
          <Margin mt={mobile ? 4 : 9} mb={3}>
            <S.TitleHolder>
              <Title as="1" levelDesktop="4" level="4" primary>
                <strong>Tudo certo com o cadastro!</strong>
              </Title>

              <StepBubbles step={step} mobile={mobile} />
              <Margin>
                <Title as="2" level="6" levelDesktop="5">
                  <S.Title>
                    Seus cupons fiscais foram cadastrados com sucesso!
                  </S.Title>
                </Title>
              </Margin>
            </S.TitleHolder>
          </Margin>


          <S.ButtonWrapper>
            <Margin mb={mobile ? 5 : 10} mt={3}>
              <Button
                className="animation-size"
                id="returnButtonFormInvoice"
                color="primary"
                type="button"
                onClick={() => history.push("/minha-conta")}
              >
                {"ACESSAR MEU PERFIL >"}
              </Button>
            </Margin>
          </S.ButtonWrapper>
        </Margin>
      </Grid>
    </S.PageContainer>
  );
}
